<script lang="ts" setup>
import { PhArrowCircleRight, PhArrowCircleLeft } from '@phosphor-icons/vue'

import { Carousel, CarouselPaginationDots, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@toni/brand-ui'

import type { Images } from '@toni/commerce-api-types'

const props = defineProps<{
  images: Images
}>()

const images = props.images || []
</script>

<template>
  <Carousel class="aspect-9/7 flex-shrink-0">
    <CarouselPrevious v-if="images.length > 1"
                      class="carousel-previous inverted"
                      :use-disabled-opacity="true">
      <PhArrowCircleLeft :size="40"
                         weight="light" />
    </CarouselPrevious>
    <CarouselContent>
      <CarouselItem
        v-for="(image, index) in images"
        :key="image.url"
        class="basis-full">
        <img
          :src="image.url"
          :alt="image.altText || `Product image: ${index}`"
          :title="image.title"
          class="carousel-image h-auto w-full justify-self-center object-contain max-h-[22rem]">
      </CarouselItem>
    </CarouselContent>
    <CarouselNext v-if="images.length > 1"
                  class="carousel-next inverted"
                  :use-disabled-opacity="true">
      <PhArrowCircleRight :size="40"
                          weight="light" />
    </CarouselNext>
    <CarouselPaginationDots v-if="images.length > 1"
                            class="carousel-pagination" />
  </Carousel>
</template>

<style scoped lang="scss">
/* styles have been added here instead of inline tailwind classes due to the white label css and the breakpoints not applying correctly when viewed in the CMS */

.carousel-next, .carousel-previous {
  @apply hidden;
}

.carousel-image {
  @apply aspect-[4/3];
}

@screen md {
  .carousel-previous, .carousel-next {
    @apply block;
  }
  .carousel-pagination {
    @apply hidden;
  }
}

@screen lg {
  .carousel-image {
    @apply aspect-video;
  }
}
</style>
